import { Injectable } from '@angular/core';
import { BaseTableStateService } from 'src/app/services/base-table-state.service';

export interface UsersFilters {
  companyID: number | null;
  journeyID: number | null;
  themesID: number[];
  domainID: number | null;
}

@Injectable({ providedIn: 'root' })
export class CbEmailTableStateService extends BaseTableStateService<UsersFilters> {
  protected getDefaultFilters(): UsersFilters {
    return {
      companyID: null,
      journeyID: null,
      themesID: [],
      domainID: null,
    };
  }
}
